import React from 'react';
import usePage from '@dashboard/hooks/usePage';
import { Form } from '@dashboard/components/Formik';
import Button from '@dashboard/components/Button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const DiscountCodeForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        showCouponCodeField: page?.showCouponCodeField,
        showCouponCodeFieldType: page?.showCouponCodeFieldType,
      }}
      fields={({ values }) => [
        {
          name: 'showCouponCodeField',
          label: 'Display discount code field',
          type: 'toggle',
        },
        ...(values.showCouponCodeField
          ? [
              {
                name: 'showCouponCodeFieldType',
                label: 'Display as',
                type: 'radio',
                options: [
                  {
                    label: '"Add discount code" link',
                    value: 'link',
                  },
                  {
                    label: 'Discount code field',
                    value: 'field',
                  },
                ],
              },
            ]
          : []),
        {
          type: 'custom',
          renderField: () => (
            <Button appearance="secondary" to="/coupons/new">
              Create coupon <ArrowRightIcon className="w-4 h-4 ml-2 align-baseline" />
            </Button>
          ),
        },
      ]}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return { data, error };
      }}
    />
  );
};

export default DiscountCodeForm;
